import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxImageMosaicComponent } from './ngx-image-mosaic.component';

@NgModule({
  declarations: [NgxImageMosaicComponent],
  imports: [CommonModule],
  exports: [NgxImageMosaicComponent],
})
export class NgxImageMosaicModule {}
